import { CompanyDto } from "#modules/company/infra/Company.dto";
import { PredictionModelTypeType } from "shared";

export const getCompanyModelType = (
  company: CompanyDto | undefined | null,
): PredictionModelTypeType | null => {
  if (company) {
    return company.companySettings.model?.type || null;
  }

  return null;
};
